import { Link } from 'react-router-dom';

export const linkedProjectColumns = (filtersRange, monthlyTotals, companiesMap) => {
  const numberFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formatValue = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? '$0.00' : '$' + numberFormatter.format(num);
  };

  const timeRangeColumns = filtersRange?.map((month, index) => {
    return {
      name: month,
      width: '0.5%',
      minWidth: '115px',
      align: 'center',
      footerAlign: 'center',
      // sortable: true,
      render: (cellData, rowData) => {
        const formattedSchedule = rowData?.formattedSchedule;
        const value = formattedSchedule?.find((x) => x?.date === month)?.value || '0.00';
        return formatValue(value);
      },
      footer: formatValue(monthlyTotals[index]),
    };
  });

  const totalColumn = {
    name: 'Total',
    width: '0.5%',
    minWidth: '115px',
    align: 'center',
    footerAlign: 'center',
    // sortable: true,
    render: (cellData, rowData) => {
      return formatValue(rowData.total);
    },
    footer: formatValue(
      monthlyTotals.reduce((sum, value) => sum + parseFloat(value.replace(/[$,]/g, '')), 0),
    ),
  };

  const baseColumns = [
    {
      name: 'ID',
      dataKey: 'id',
      width: '0.5%',
      minWidth: '80px',
      align: 'left',
      footerAlign: 'left',
      sortable: true,
      defaultSort: { direction: 'asc' },
    },
    {
      name: 'Project Name',
      sortable: true,
      dataKey: 'projectName',
      width: '0.5%',
      minWidth: '300px',
      align: 'left',
      footerAlign: 'right',
      footer: 'Totals',
      render: (cellData, rowData) => {
        const projectUrl = `/projectsview/${rowData.id}/details?isGroupView=false`;
        return (
          <Link
            to={projectUrl}
            target="_blank"
            style={{
              textDecoration: 'underline',
              color: 'inherit',
              cursor: 'pointer',
            }}
          >
            {cellData}
          </Link>
        );
      },
    },

    {
      name: 'Client',
      dataKey: 'clientName', // ← sort will now use the name
      width: '0.5%',
      minWidth: '300px',
      align: 'left',
      footerAlign: 'left',
      sortable: true,
      render: (cellData, rowData) => {
        const clientUrl = `/companiesView/${rowData.client}/details`;
        return (
          <Link
            to={clientUrl}
            target="_blank"
            style={{
              textDecoration: 'underline',
              color: 'inherit',
              cursor: 'pointer',
            }}
          >
            {cellData}
          </Link>
        );
      },
    },
    {
      name: 'Project Lead',
      dataKey: 'projectLead',
      width: '0.5%',
      minWidth: '180px',
      align: 'left',
      footerAlign: 'left',
      sortable: true,
      render: (cellData, rowData) => {
        // Try both possible keys for lead
        return rowData.projectLead || rowData.lead || '-';
      },
    },

    {
      name: 'State',
      dataKey: 'state',
      width: '0.5%',
      minWidth: '115px',
      align: 'left',
      footerAlign: 'left',
      sortable: true,
    },

    {
      name: 'Probability',
      dataKey: 'probability',
      width: '0.5%',
      minWidth: '115px',
      align: 'left',
      footerAlign: 'left',
      sortable: true,
      render: (cellData, rowData) => {
        return <span>{rowData.probability}%</span>;
      },
    },
  ];

  return [...baseColumns, ...timeRangeColumns, totalColumn];
};
